import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDataProvider } from 'src/mtska-frontend-data-provider'
import { AppContext, useAppSettingsContext } from '../contexts';

export const useLegalEntityOptions = () => {

    const { loadAll } = useDataProvider('companies/selectablelegalentity');
    const { appConfiguration } = useContext(AppContext);
    const { settingsLoaded } = useAppSettingsContext();

    const { t } = useTranslation()

    const [legalEntityOptions, setLegalEntityOptions] = useState()

    useEffect(() => {
        if (!legalEntityOptions && settingsLoaded && appConfiguration?.legalEntitySelector?.active === true) {
            const onError = () => setLegalEntityOptions([])
            const onSuccess = (data) => {
                const { items } = data || {}
                const { data: options } = items || {}
                const optionAll = appConfiguration?.legalEntitySelector?.canSeeAllButton ? [{ id: 'all', name: t('all') }] : []
                setLegalEntityOptions([...optionAll, ...options] || [])
            }
            loadAll().then(onSuccess).catch(onError)
        }
    }, [legalEntityOptions, settingsLoaded, appConfiguration])

    return { legalEntityOptions, setLegalEntityOptions }
}